import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveEnterprise } from "../redux/actions/administrador/config/configs";
import Swal from "sweetalert2";

// Centraliza selección de empresas a nivel de UI
export const useEnterpriseSelection = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { selected_enterprise_id } = useSelector((state) => state.config);

    const enterprises = useMemo(() => user?.enterprises || [], [user]);

    const activeEnterprise =
        selected_enterprise_id &&
        enterprises.find((e) => e.id === selected_enterprise_id)
            ? enterprises.find((e) => e.id === selected_enterprise_id)
            : null;

    const handleSelectEnterprise = (enterprise) => {
        dispatch(setActiveEnterprise(enterprise ? enterprise.id : null));

        // Feedback visual al usuario
        const logo = enterprise?.uri
            ? `<img src="${enterprise.uri}" alt="logo" style="width:40px;height:40px;object-fit:cover;border-radius:4px;margin-right:8px;" />`
            : `<div style="width:40px;height:40px;border-radius:4px;margin-right:8px;background:#e5e7eb;display:flex;align-items:center;justify-content:center;font-weight:bold;color:#374151;text-transform:uppercase;">${enterprise?.tiny_name?.slice(0, 2) || "-"}</div>`;

        Swal.fire({
            toast: true,
            position: "top",
            icon: enterprise ? "success" : "info",
            title: enterprise ? "Empresa activa" : "Sin empresa activa",
            html: enterprise
                ? `<div class="d-flex align-items-center">
                        ${logo}
                        <div>
                            <div style="font-weight:bold;">${enterprise.tiny_name}</div>
                            <div style="font-size:12px;">${enterprise.rfc || "RFC no registrado"}</div>
                        </div>
                   </div>`
                : "Selecciona una empresa para continuar",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
        });
    };

    // Si la empresa seleccionada ya no está disponible, limpiar y notificar
    useEffect(() => {
        if (selected_enterprise_id && !activeEnterprise) {
            dispatch(setActiveEnterprise(null));
            Swal.fire({
                toast: true,
                position: "top",
                icon: "info",
                title: "Selecciona una empresa",
                text: "La empresa previa ya no está disponible.",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
        }
    }, [selected_enterprise_id, activeEnterprise, dispatch]);

    return {
        enterprises,
        activeEnterprise,
        selectedEnterpriseId: selected_enterprise_id,
        hasEnterprises: enterprises.length > 0,
        handleSelectEnterprise,
    };
};
